import { useContext } from 'react';
import { isMobile } from '../../services/DeviceInformation';
import PageContainerDesktop from './PageContainerDesktop';
import PageContainerMobile from './PageContainerMobile';
import Loading from '../Loading';
import LoadingScreenContext from '../../services/LoadingScreenContext';

const PageContainer = ({ title, children }) => {
    const { loading } = useContext(LoadingScreenContext);

    if (isMobile()) {
        return (
            <PageContainerMobile title={title}>
                {loading && <Loading />}
                {children}
            </PageContainerMobile>
        );
    }
    return (
        <PageContainerDesktop title={title}>
            {loading && <Loading />}
            {children}
        </PageContainerDesktop>
    );
};

export default PageContainer;
